import { isNil } from 'ramda';
import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  onClick?: () => void;
};

const TableContainerStandard: React.FCC<Props> = ({ children, onClick }) => (
  <Container $onClick={!isNil(onClick)} onClick={onClick}>
    {children}
  </Container>
);

const Container = styled.div<{ $onClick?: boolean }>(
  ({ $onClick }) => css`
    user-select: none;
    border-spacing: 0;

    ${$onClick &&
    css`
      cursor: pointer;
    `}
  `,
);

export default TableContainerStandard;
